import { BidPackageReleasedStatus } from "@btnet/services-btnet/handlers/models/bidPackageReleasedStatus";

import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";

export function getBidPackageReleasedStatusText(status: number): string {
    switch (status as BidPackageReleasedStatus) {
        case BidPackageReleasedStatus.Released:
            return "Released";
        case BidPackageReleasedStatus.Unreleased:
            return "Unreleased";
        default:
            return "";
    }
}

export function getBidPackageReleasedStatusType(status: number): StatusTypes {
    switch (status as BidPackageReleasedStatus) {
        case BidPackageReleasedStatus.Released:
            return "pending";
        default:
            return "";
    }
}
